<template>
  <div :class="[
      // 'pt-4',
      'barra-branca', 
      ]" 
      data-app
    >
    
    <v-row class="" >
        <v-col cols="12" class="left-column event-form" style="position: relative">
          <mc-progress-bar
            :active="fetching"
            contex="event-create"
            label="Obtendo informações do evento..."
          ></mc-progress-bar>
          <v-btn 
            fab
            dense
            outlined
            @click="backToEvents" 
            class=" text-none mb-3 back-btn"
            :disabled="fetching"
          >
            <v-icon>
              mdi-arrow-left
            </v-icon>
          </v-btn>
          <!-- <v-btn 
            v-if="eventName || $route.params?.id"
            fab
            dense
            outlined
            @click="backToEvents" 
            class=" text-none my-3 back-btn"
            :disabled="fetching"
          >
            <v-icon>
              mdi-account-plus
            </v-icon>
          </v-btn> -->

          <div >
            <validation-observer ref="newevent">
                  <v-form 
                    :disabled="fetching" 
                    :read-only="fetching" 
                    class="mc-form"
                  >
                    <v-row>
                      <v-col cols="12" >
                      
                        <h3 class="">Nome</h3>
                        <validation-provider name="Name" vid="eventName" rules="required">
                          <v-text-field
                            class="name-box"
                            v-model="eventName"
                            label="Nome"
                            rows="1"
                            solo
                            outlined
                            flat
                            hide-details
                          ></v-text-field>
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" >
                        <h3>Breve Descrição</h3>
                        <v-textarea
                          class="description-box"
                          label="Descrição"
                          v-model="eventDescription"
                          outlined
                          solo
                          flat
                          hide-details
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" >
                        <h3>Duração</h3>
                        <div>
                          <v-select
                            v-model="duracaoSelecionada"
                            label="Selecione a duração"
                            :items="['Horas', 'Dia(s)', 'Semanal', 'Quinzenal', 'Mensal']"
                            outlined
                            solo
                            flat
                            style="border-radius: 30px; margin-top: 15px"
                          ></v-select>
                          <v-select
                            v-if="duracaoSelecionada === 'Horas' || duracaoSelecionada === 'Dia(s)'"
                            v-model="subDuracaoSelecionada"
                            :items="opcoesFiltradas"
                            :label="labelDetalhada"
                            outlined
                            solo
                            flat
                            style="border-radius: 30px; margin-top: 15px"
                          ></v-select>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" v-if="subDuracaoSelecionada || duracaoSelecionada === 'Mensal' || duracaoSelecionada === 'Quinzenal' || duracaoSelecionada === 'Semanal'">
                          <div class="show-calendar">
                              <v-btn 
                                  :style="{ backgroundColor: !isDisabled ? '#E9CFED' : '#fff' }"
                                  class="fixed-calendar-btn"
                                  fab 
                                  x-small 
                                  outlined 
                                  dense 
                                  @click="activeDate"
                                  @input="saveDates"
                              >
                                  <v-icon>mdi-calendar-month-outline</v-icon>
                              </v-btn>
                    <div :style="{ display: 'flex', flexDirection: !isDisabled ? 'column' : 'row' }">
                      <div>
                      <template v-if="!isDisabled">
                        <v-date-picker 
                          full-width
                          v-model="selectedDates" 
                          multiple 
                          no-title 
                          class="c-date-picker" 
                          @input="handleDateSelection" 
                          direction="top" 
                          :allowed-dates="allowedDates"
                          attach="body" 
                          left 
                          :events="specialDates"
                          :event-color="getEventColor"
                        >
                          </v-date-picker>
                      </template>
                    </div>
                    <v-col cols="12">
                      <v-card class="selected-dates-card" v-if="selectedDates.length > 0" elevation="0">
                        <v-card-text>
                          <v-chip
                            v-for="(interval, index) in getIntervalos(selectedDates)"
                            :key="index"
                            class="ma-1"
                            outlined
                          >
                            {{ new Date(interval[0]).toLocaleDateString('pt-PT', { day: 'numeric', month: 'numeric' }) }}
                            <template v-if="interval.length > 1">
                              a {{ new Date(interval[interval.length - 1]).toLocaleDateString('pt-PT', { day: 'numeric', month: 'numeric' }) }}
                            </template>
                            <v-btn @click="removeInterval(interval)" x-small rounded icon class="elevation-0 transparent">
                              <v-icon x-small style="font-size: 15px; margin-left: 10px;">
                                mdi-close
                              </v-icon>
                            </v-btn>
                          </v-chip>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    </div>
                  </div>
                  </v-col>
                    <v-col cols="12"  class="">
                      <v-btn :disabled="isAbleToSave()" class="create-btn" rounded large block color="black" @click="createEvent">Guardar</v-btn>
                    </v-col>
                  </v-row>
                </v-form> 
            </validation-observer>
            
          </div>
        </v-col>
        <v-col cols="12" md="6" class="right-column d-none d-md-flex justify-md-center pa-0">
        <v-img
          src="@/assets/papelEventos1.png"
          alt="Imagem de Login"
          max-width="100%"
          height="auto"
          contain
          class="img_size"
        />
      </v-col>
    </v-row>

      
    <v-dialog v-model="timeDialog" max-width="600px" max-height="600px" class="time-dialog" scrollable>
      <v-card class="card-times-create">
        <v-card-title class="background-image sticky-title">
          {{ formatarData(selectedDate) }}
          <v-spacer></v-spacer>
          <v-btn icon color="black" @click="closeTimeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          
        </v-card-title>

        <v-card-text class="card-times-scroll">
          <v-row class="time-row my-4">
            <v-col cols="6" v-for="time in timeOptions" :key="time">
              <v-list-item
                @click="toggleTime(time)" dense
                :class="['time-item', { 'selected-time': isTimeSelected(time), 'not-selected-time': !isTimeSelected(time) }]"
              >
                <v-list-item-content class="costumize-time-select">{{ time }}</v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import Events from '@/api/Events.js';

export default {
  data() {
    return {
      eventName: '',
      eventDescription: '',
      selectedDates: [],
      dates: [],
      datesFormatted: '',
      menu: false,
      isDisabled: true,
      timeDialog: false,
      selectedDate: null,
      times: {}, 
      firstTime: true,
      duracaoSelecionada: null,
      subDuracaoSelecionada: null,
      labelsDetalhadas: {
        Horas: 'Selecione as horas',
        'Dia(s)': 'Selecione os dias',
      },
      opcoesDetalhadas: {
        Horas: ['1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10h', '11h', '12h'],
        'Dia(s)': ['1 dia', '2 dias', '3 dias', '4 dias', '5 dias', '6 dias'],
        Semanal: ['1 semana', '3 semanas'],
        Quinzenal: ['15 dias'],
        Mensal: ['1 mês', '2 meses', '3 meses', '4 meses', '5 meses', '6 meses', '7 meses', '8 meses', '9 meses', '10 meses', '11 meses', '12 meses']
      },
      timeOptions: [
        '00:00 - 00:30', '00:30 - 01:00', '01:00 - 01:30', '01:30 - 02:00', '02:00 - 02:30', '02:30 - 03:00', '03:00 - 03:30', '03:30 - 04:00', '04:00 - 04:30', '04:30 - 05:00', '05:00 - 05:30', '05:30 - 06:00',
        '06:00 - 06:30', '06:30 - 07:00', '07:00 - 07:30',
        '07:30 - 08:00', '08:00 - 08:30', '08:30 - 09:00', '09:00 - 09:30', '09:30 - 10:00', '10:00 - 10:30', '10:30 - 11:00', '11:00 - 11:30',
        '11:30 - 12:00', '12:00 - 12:30', '12:30 - 13:00', '13:00 - 13:30', '13:30 - 14:00', '14:00 - 14:30', '14:30 - 15:00', '15:00 - 15:30',
        '15:30 - 16:00', '16:00 - 16:30', '16:30 - 17:00', '17:00 - 17:30', '17:30 - 18:00', '18:00 - 18:30', '18:30 - 19:00', '19:00 - 19:30',
        '19:30 - 20:00', '20:00 - 20:30', '20:30 - 21:00', '21:00 - 21:30', '21:30 - 22:00', '22:00 - 22:30', '22:30 - 23:00', '23:00 - 23:30', '23:30 - 23:59'
      ],
      isLoadingEvent: false,
      dateRanges: [],
      startDate: null,
      endDate: null,
      fetching: false,
      failedFetching: false,
      options: [
          { value: 1, class: 'red-button' },
          { value: 2, class: 'yellow-button' },
          { value: 3, class: 'green-button' },
          { value: 0, class: 'x-button' },
        ],
      selectedOption: 0,
    };
  },
  watch:{
    duracaoSelecionada() {
      if (this.isLoadingEvent) return;
      if (this.selectedDates.length > 0) {
        this.selectedDates = [];
        this.times = {}; 
      }
    },

    subDuracaoSelecionada() {
      if (this.isLoadingEvent) return;
      if (this.selectedDates.length > 0) {
        this.selectedDates = [];
        this.times = {};
        this.datesFormatted = '';
      }
    },

    selectedDates(newDates, oldDates) {
    const changedDate = newDates.find(date => !oldDates.includes(date)) || oldDates.find(date => !newDates.includes(date));

    if (!changedDate) return;

    this.openTimeDialog(changedDate);

    if (!newDates.includes(changedDate)) {
      this.selectedDates.push(changedDate);
    }

    this.$nextTick(() => {
      const buttons = document.querySelectorAll('.v-date-picker-table .v-btn.v-btn--disabled');

      buttons.forEach(btn => {
        const day = parseInt(btn.textContent.trim()); // pega o número do dia
        const btnDate = this.selectedDates.find(d => new Date(d).getDate() === day);
        if (btnDate) {
          btn.classList.add('selected-date');
        }
      });
    });
  }
  },

  methods: {
    getDayClass(date) {
    // se a data já está selecionada, adiciona a classe extra
    console.log('data selecionada:', date, this.selectedDates);
    if (this.selectedDates.includes(date)) {
      console.log('data selecionada:', date);
      return 'btn-active';
    }
    return '';
    },
    getIntervalos(selectedDates) {
      if (!selectedDates || selectedDates.length === 0) return [];
      const sortedDates = [...selectedDates].sort((a, b) => new Date(a) - new Date(b));
      return this.agruparIntervalos(sortedDates);
    },
    removeInterval(interval) {
      if (!interval.length) return;

      // using .sort() and then taking the first and last elements of interval
      // in case this ever gets an array with more than two values
      interval.sort();
      const startDateStr = interval.at(0);
      const endDateStr = interval.at(-1);
      // find the range that matches the start and end dates
      const range_index = this.dateRanges.findIndex(
        (range_) => range_?.start === startDateStr && range_?.end === endDateStr
      );

      // guard against -1 to prevent accidentally deleting the last item in the array
      if (range_index !== -1) {
        // splicing dateRanges array automatically updates the startDates and endDates computed properties.
        this.dateRanges.splice(range_index, 1);
      }

      // Iterate over the whole interval to ensure middle dates are wiped from the UI and state
      interval.forEach(date => {
        // Remove from the v-model so the calendar removes the active state
        const i = this.selectedDates.indexOf(date);
        if (i !== -1) {
          this.selectedDates.splice(i, 1);
          
          // clear the time data for every day in the range
          this.$delete(this.times, date);
        }
      });

      // MC-308 - Alice Serina - 26/02/2026
      // this point in the code was previously performing 'this.dateRanges = [];'. 
      // However, this approach would result in all intervals loosing the styling for
      // the first and last day since those are computed from this.dateRanges. 
      // The desired interval was already removed anyway so no need to reset the value.

      // reset these to prevent mid-selection bugs on subsequent clicks
      this.startDate = null;
      this.endDate = null;
    },
    isAbleToSave() {
      if (this.duracaoSelecionada === 'Horas') {
        return !this.times[this.selectedDate] || this.times[this.selectedDate].length / 2 < this.minDuration;
      } else {
        return !this.selectedDates || this.selectedDates.length < this.minDuration;
      }
    },
    handleDateSelection() {
      const newDate = this.selectedDates[this.selectedDates.length - 1];

      // ✅ CASO ESPECIAL: Dia(s) + 1 dia => NÃO criar ranges, só adicionar a data
      if (this.duracaoSelecionada === 'Dia(s)' && this.minDuration === 1) {
        // limpa estado de ranges para não contaminar seleções futuras
        this.dateRanges = [];
        this.startDate = null;
        this.endDate = null;

        // garante que não há duplicados
        this.selectedDates = [...new Set(this.selectedDates)];

        return;
      }
      // MC 329 - Alice Serina - 20/02/2026
      // Need to reset start date to null when event duration is hours
      // otherwise when the user selects another day, this will be used as the start of a range
      else if (this.duracaoSelecionada === "Horas")
      {
        this.startDate = null;
      }

      // --- A TUA LÓGICA ATUAL (ranges) ---
      if (!this.selectedDates.includes(newDate)) {
        this.selectedDates.push(newDate);
      }

      if (this.startDate === null) {
        this.startDate = newDate;
      } else if (this.endDate === null) {
        this.endDate = newDate;
        // MC-360 - Alice Serina - 26/02/2026
        // need to swap date values if the end is smaller than the start otherwise this will create two separate ranges and apply the wrong style to both dates
        if (this.endDate < this.startDate) {
          this.endDate = this.startDate;
          this.startDate = newDate;
        }
        this.dateRanges.push({ start: this.startDate, end: this.endDate });
        this.startDate = null;
        this.endDate = null;
      }

      const allDates = [];
      this.dateRanges.forEach(range => {
        const startDate = new Date(range.start);
        const endDate = new Date(range.end);
        while (startDate <= endDate) {
          allDates.push(startDate.toISOString().split('T')[0]);
          startDate.setDate(startDate.getDate() + 1);
        }
      });

      this.selectedDates = [...new Set([...this.selectedDates, ...allDates])];

      this.openTimeDialog(newDate);
    },
    // MC-308 - Alice Serina - 26/02/2026
    // determines which style (css class) to apply based on if it is a Start or End date 
    getEventColor(date) {
      // check if it is an End Date (prioritize this for the 'invert' style)
      if (this.endDates.includes(date)) {
        return "range-end"; 
      }
      // 2. Check if it is a Start Date
      if (this.startDates.includes(date)) {
        return "range-start"; 
      }
      return null;
    },
    formatarData(data) {
      const date = new Date(data);
      return date.toLocaleDateString("pt-PT", { day: "2-digit", month: "long" });
    },

    removeDate(data) {
      const i = this.selectedDates.indexOf(data);
      if (i !== -1) {
        this.selectedDates.splice(i, 1);
        this.$delete(this.times, data);
      }
      this.dateRanges = [];
      this.startDate = null;
      this.endDate = null;
    },
    allowedDates(date) {
      // date vem em 'YYYY-MM-DD'
      const today = new Date(); 
      today.setHours(0, 0, 0, 0);

      const d = new Date(date);
      const isFutureOrToday = d >= today;

      // se a data já está selecionada, fica desativada no calendário
      const notAlreadySelected = !this.selectedDates.includes(date);

      return isFutureOrToday && notAlreadySelected;
    },

    formatDates() {
      this.datesFormatted = this.selectedDates.join(', ');
    },

    backToEvents() {
      this.$router.push({ name: 'Events' });
    },

    saveDates() {
      this.datesFormatted = this.dates.map(date => new Date(date).toLocaleDateString()).join(', ');
    },

    activeDate() {
      this.isDisabled = !this.isDisabled;
    },

    obterUnidade(tipo) {
      switch (tipo) {
        case 'Horas':
          return 'hours';
        case 'Dia(s)':
          return 'days';
        case 'Semanal':
          return 'weeks';
        case 'Quinzenal':
          return 'fortnight';
        case 'Mensal':
          return 'month';
        default:
          return '';
      }
    },

    generate30DayRange(startDate) {
      const dates = [];
      const base = new Date(startDate);
      for (let i = 0; i < 30; i++) {
        const next = new Date(base);
        next.setDate(base.getDate() + i);
        dates.push(next.toISOString().split('T')[0]);
      }
      return dates;
    },

    generateDayRange(startDate, count) {
      const dates = [];
      const base = new Date(startDate);
      for (let i = 0; i < count; i++) {
        const next = new Date(base);
        next.setDate(base.getDate() + i);
        dates.push(next.toISOString().split('T')[0]);
      }
      return dates;
    },

    openTimeDialog(dates) {
      // Garante que 'dates' é um array, mesmo quando só uma data é selecionada
      const selectedArray = Array.isArray(dates) ? dates : [dates];
      const lastSelectedDate = selectedArray[selectedArray.length - 1];
      
      if (lastSelectedDate && this.duracaoSelecionada === 'Horas') {
        this.selectedDate = lastSelectedDate;

        if (!this.times[this.selectedDate]) {
          // Aqui é onde adicionamos todos os horários como padrão
          this.$set(this.times, this.selectedDate, [...this.timeOptions]);
        }

        // Abre o diálogo
        if (this.$route.params.id) {
          if (this.firstTime) {
            this.firstTime = false;
            return;
          }
        }

        if (!dates) return;

        this.selectedDate = dates;

        // Verifica se já existem times guardados para a data
        if (!this.times[this.selectedDate]) {
          this.$set(this.times, this.selectedDate, [...this.timeOptions]);
        } else {
          // Se já existem times, remove possíveis duplicatas
          this.times[this.selectedDate] = [
            ...new Set(
              this.times[this.selectedDate].map(t =>
                typeof t === 'object' ? t.time : t
              )
            )
          ];
        }

        this.timeDialog = true;

        this.$nextTick(() => {
          setTimeout(() => {
            const container = document.querySelector('.v-dialog .card-times-scroll');
            const timeItems = container?.querySelectorAll('.time-item');
            const selectedTime = Array.from(timeItems || []).find(item =>
              item.textContent.includes('06:00 - 06:30')
            );

            if (selectedTime && container) {
              selectedTime.scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
            }
          }, 200); 
        });

      }
    },

    toggleTime(time) {
      if (!this.selectedDate) return;

      if (!this.times[this.selectedDate]) {
        this.$set(this.times, this.selectedDate, [...this.timeOptions]); 
      }

      const allSelected = this.times[this.selectedDate].length === this.timeOptions.length;

      if (allSelected) {
        this.$set(this.times, this.selectedDate, []); 
      } else {
        const isAlreadySelected = this.times[this.selectedDate].includes(time);
        if (isAlreadySelected) {
          this.times[this.selectedDate] = this.times[this.selectedDate].filter(t => t !== time);
        } else {
          console.log('time selecionado', time, this.times, this.selectedDate);
          this.times[this.selectedDate].push(time);
        }
      }

    },

    isTimeSelected(time) {
      if (!this.selectedDate || !this.times[this.selectedDate]) {
        return false;
      }
      return this.times[this.selectedDate].includes(time);
    },

    closeTimeDialog() {
      this.timeDialog = false;
    },

    selectTime(time) {
      if (!this.selectedDate) {
        console.error('Nenhuma data selecionada!');
        return;
      }

      // Inicializa a lista de horários 
      if (!this.times[this.selectedDate]) {
        this.times[this.selectedDate] = [];
      }

      const index = this.times[this.selectedDate].indexOf(time);
      if (index === -1) {
        this.times[this.selectedDate].push(time);  // Adiciona a hora se não estiver selecionada
      } else {
        this.times[this.selectedDate].splice(index, 1);  // Remove a hora se já estiver selecionada
      }

      console.log('Horas selecionadas para', this.selectedDate, ':', this.times[this.selectedDate]);
    },

    agruparIntervalos(dates) {
      if (!dates || dates.length === 0) return [];
      // Ordena as datas
      const sorted = [...dates].sort((a, b) => new Date(a) - new Date(b));
      const intervalos = [];
      let intervaloAtual = [sorted[0]];

      for (let i = 1; i < sorted.length; i++) {
        const dataAnterior = new Date(sorted[i - 1]);
        const dataAtual = new Date(sorted[i]);
        // Verifica se é consecutivo (diferença de 1 dia)
        if (this.duracaoSelecionada !== "Horas" && (dataAtual - dataAnterior) === 24 * 60 * 60 * 1000) {
          intervaloAtual.push(sorted[i]);
        } else {
          intervalos.push(intervaloAtual);
          intervaloAtual = [sorted[i]];
        }
      }
      intervalos.push(intervaloAtual);
      return intervalos;
    },

    async createEvent() {
      const completeTimes = {};
      
      // Se nenhuma hora for selecionada, atribuir todas as horas
      this.selectedDates.forEach(date => {
        if (!this.times[date] || this.times[date].length === 0) {
          completeTimes[date] = [...this.timeOptions];
        } else {
          completeTimes[date] = this.times[date];
        }
      });

      const intervals = [];

      this.agruparIntervalos(this.selectedDates).forEach(intervalo => {
       if (this.duracaoSelecionada === 'Horas') {
          intervalo.forEach(date => {
            const times = this.times[date] || [];
            if (times.length > 0) {
              let startTime = null;
              let prevEndTime = null;

              times.forEach((timeRange, index) => {
                const [start, end] = timeRange.split(' - ');

                if (!startTime) {
                  startTime = start; 
                }

                if (prevEndTime && prevEndTime !== start) {
                  intervals.push({
                    start_datetime: `${date}T${startTime}:00`,
                    end_datetime: `${date}T${prevEndTime}:00`
                  });
                  startTime = start; 
                }

                prevEndTime = end;

                if (index === times.length - 1) {
                  intervals.push({
                    start_datetime: `${date}T${startTime}:00`,
                    end_datetime: `${date}T${end}:00`
                  });
                }
              });
            }
          });
        } else {
          const startDate = intervalo[0];
          const endDate = intervalo[intervalo.length - 1];

          const startTimes = this.times[startDate] || [];
          const endTimes = this.times[endDate] || [];

          const startTime = startTimes.length > 0
            ? startTimes[0].split(' - ')[0]
            : '00:00';
          const endTime = endTimes.length > 0
            ? endTimes[endTimes.length - 1].split(' - ')[1]
            : '23:59';

          intervals.push({
            start_datetime: `${startDate}T${startTime}:00`,
            end_datetime: `${endDate}T${endTime}:00`
          });
        }
      });
      
      const minDuration = () => {
        if (this.duracaoSelecionada === 'Horas' || this.duracaoSelecionada === 'Dia(s)') {
          return parseInt(this.subDuracaoSelecionada);
        } else if (this.duracaoSelecionada === 'Semanal') {
          return 7;
        } else if (this.duracaoSelecionada === 'Quinzenal') {
          return 15;
        } else if (this.duracaoSelecionada === 'Mensal') {
          return 30;
        }
      }


      const params = {
        title: this.eventName,
        description: this.eventDescription,
        duration_type: this.obterUnidade(this.duracaoSelecionada),
        min_duration: minDuration(),
        intervals: intervals
      };

      console.log('dados evento:', params);

      try {
        if (this.$route.params.id) {
          await Events.update(this.$route.params.id, params);
          console.log('Evento atualizado');
        } else {
          await Events.create(params);
          console.log('Evento criado');
        }
        this.$router.push({ name: 'Events' });
      } catch (error) {
        console.error('Erro ao salvar evento:', error);
      }
    },
    generateDatesInRange(start, end) {
      const startDate = start.split(' ')[0]; 
      const endDate   = end.split(' ')[0];   

      const dates = [];
      let current = new Date(startDate);
      const last  = new Date(endDate);

      while (current <= last) {
        dates.push(current.toISOString().slice(0, 10));
        current.setDate(current.getDate() + 1);
      }

      return dates;
    },
    async loadEvent() {
      if (this.$route.params.id) {
        this.fetching = true;
        try {
          const response = await Events.get(this.$route.params.id);
          const event = response.data;
          this.eventName = event.title;
          this.eventDescription = event.description;
          this.selectedDates = event.intervals
          .flatMap(i => this.generateDatesInRange(i.start_datetime, i.end_datetime));
          this.times = {};
          event.intervals.forEach(interval => {
            const date = interval.start_datetime.split(" ")[0];
            const startTime = interval.start_datetime.split(" ")[1].slice(0, 5); // "HH:mm"
            const endTime = interval.end_datetime.split(" ")[1].slice(0, 5);

            // preenche times[date] com as opções entre startTime e endTime
            this.times[date] = this.timeOptions.filter(opt => {
              const [start, end] = opt.split(" - ");
              return start >= startTime && end <= endTime;
            });
          });
          this.duracaoSelecionada = this.mapDurationUnit(event.duration_type);
          this.subDuracaoSelecionada = this.mapDurationValue(event.min_duration, event.duration_type);
          this.isLoadingEvent = true;
          console.log('Evento carregado:', this.times);
        } catch (error) {
          this.isLoadingEvent = false;
          console.error('Erro ao carregar evento:', error);
          this.failedFetching = true;
        }
        finally {
          this.fetching = false;
        }
      }
    },

    mapDurationUnit(unit) {
      switch (unit) {
        case 'hours':
          return 'Horas';
        case 'months':
          return 'Mensal';
        case 'days':
          return 'Dia(s)';
        case 'weeks':
          return 'Semanal';
        case 'fortnights':
          return 'Quinzenal';
        default:
          return 'Selecione';
      }
    },

   mapDurationValue(value, unit) {
    switch (unit) {
      case 'hours':
        switch (value) {
          case 1:
            return '1h';
          case 2:
            return '2h';
          case 3:
            return '3h';
          case 4:
            return '4h';
          case 5:
            return '5h';
          case 6:
            return '6h';
          case 7:
            return '7h';
          case 8:
            return '8h';
          case 9:
            return '9h';
          case 10:
            return '10h';
          case 11:
            return '11h';
          case 12:
            return '12h';
          default:
            return 'Selecione';
        }
      case 'days':
        switch (value) {
          case 1:
            return '1 dia';
          case 2:
            return '2 dias';
          case 3:
            return '3 dias';
          case 4:
            return '4 dias';
          case 5:
            return '5 dias';
          case 6:
            return '6 dias';
          default:
            return 'Selecione';
        }
      default:
        return 'Selecione';
    }
  }
  },

  created() {
    this.loadEvent();
  },

  computed: {
    // MC-308 - Alice Serina - 26/02/2026
    // created computed properties to keep track of start and end dates for ranges
    // since these are computed properties, they are automatically updated if a range gets added or removed from this.dateRanges
    startDates() {
      return this.dateRanges.reduce(
        (start_dates, range_) => {
          // if range_ has a start prop and it's truthy add it, otherwise keep start_dates as is
          if (range_?.start) {
            start_dates.push(range_.start);
          }
          return start_dates
        },
        // initial value for start_dates 
        []
      );
    },
    endDates() {
      return this.dateRanges.reduce(
        (end_dates, range_) => {
          // if range_ has a end prop and it's truthy add it, otherwise keep end_dates as is
          if (range_?.end) {
            end_dates.push(range_.end);
          }
          return end_dates
        },
        // initial value for end_dates 
        []
      );
    },
    // Collects all Start and End dates into one array for the 'events' prop
    specialDates() {
      return [...this.startDates, ...this.endDates]
    },
    sortedSelectedDates() {
      return [...this.selectedDates].sort((a, b) => new Date(a) - new Date(b));
    },
     labelDetalhada() {
      return this.labelsDetalhadas[this.duracaoSelecionada] || 'Selecione';
    },
     opcoesFiltradas() {
      return this.opcoesDetalhadas[this.duracaoSelecionada] || [];
    },
     minDuration() {
      if (this.duracaoSelecionada === 'Horas' || this.duracaoSelecionada === 'Dia(s)') {
        return parseInt(this.subDuracaoSelecionada);
      } else if (this.duracaoSelecionada === 'Semanal') {
        return 7;
      } else if (this.duracaoSelecionada === 'Quinzenal') {
        return 15;
      } else if (this.duracaoSelecionada === 'Mensal') {
        return 30;
      }
      return 0;
    }
  }

};
</script>

<style scoped lang="scss">

    .calendar-container {
        display: flex;
        align-items: center; /* Alinha verticalmente o ícone e o texto */
        gap: 9px; /* Espaço entre o ícone e o texto */
        margin-right: 2px;
    }

    .fixed-calendar-btn {
        flex-shrink: 0; /* Evita que o botão encolha */
        position: relative; /* Mantém a posição mesmo que o layout mude */
        height: 48px;
        width: 48px;
    }

    .event-layout {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100vh;
    }

    .events-create-bg {
      background-color: #ffffff; /* Cor de fundo específica para esta view */
      
    }

    .title {
      margin-bottom: 20px;
    }

    .show-calendar {
      display: flex; 
      flex-direction: column;
      margin-bottom: 2rem;
    }
    .selected-time {
      background-color: #e9cfed; /* Cor de fundo para horas selecionadas */
    }

    .not-selected-time {
      background-color: #fff; /* Cor de fundo para horas não selecionadas */
      border: 1px solid #000 !important;
    }

    .selected-dates-card {
      border-radius: 10px;
      box-shadow: none;
      max-width: 550px;
    }

    .v-chip {
      border: 1px solid #000 !important;
      padding: 1.7rem 1rem;
      border-radius: 40px;
      width: 150px;
    }

    ::v-deep(.v-chip .v-chip__content){
      width: 100% !important;
      justify-content: space-between !important;
    }

    .v-card__text {
      padding: 0 !important;
    }

    .v-picker {
      border-radius: 10px;
      border: 1px solid #000 !important;
      margin-left: 1rem;
    }
    // MC-308 - Alice Serina - 26/02/2026
    // added styling to .v-date-picker-table's events functionality 
    // to better show the start and end date of a range.
    ::v-deep(.v-date-picker-table .v-btn.selected-date) {
      // use css variables so it only needs to be updated here if needed
      // these will be used for positioning with calc() and will trickle down to child elements
      --date-border-width: 2px;
      --marker-size: 8px;
      --marker-border-width: 0px;
      --marker-h-offset: calc(-4px - var(--marker-size) - var(--marker-border-width) - var(--date-border-width));
      --marker-v-offset: calc(50% - ((var(--marker-size) + var(--marker-border-width)) / 2));
      
      background-color: var(--app-color-bg-primary) !important;
      border-radius: 0;
      // set a border width, style and transparent color so that all buttons / days
      // have exactly the same size and color. this also makes it easier to update 
      // the style of start and end days if needed in the future since each property can be 
      // targetted individually
      border-width: var(--date-border-width);
      border-style: solid;
      border-color: transparent;
      color: var(--app-color-text-primary) !important;

      // define the general style for start and end date markers (v-date-picker events)
      & .v-date-picker-table__events {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        bottom: 0;
        transform: none;
        z-index: 0;
        // styling the event marker ("dot")
        & > div {
          
          position: absolute;
          width: var(--marker-size);
          height: var(--marker-size);
          border-style: solid;
          border-width: var(--marker-border-width);
          border-color: transparent;
          border-radius: 50%;
          top: var(--marker-v-offset);
        }
      }  
      // override colors for border and marker in start day
      &:has(.range-start) {
        border-color: var(--app-color-text-primary);

        & .v-date-picker-table__events > div {
          left: var(--marker-h-offset);
          background-color: var(--app-color-text-primary) !important;
        }
      }
      // override colors for border and marker in end day
      &:has(.range-end) {
        background-color: var(--app-color-text-primary) !important;
        color: var(--app-color-bg-secondary) !important;
        border-color: var(--app-color-bg-primary);

        & .v-date-picker-table__events > div {
          right: var(--marker-h-offset);
          background-color: var(--app-color-bg-primary);
        }
      }

      
    }
    

    ::v-deep(.v-date-picker-table .v-btn.v-btn--active) {
      background-color: #E9CFED !important;
      color: #000 !important;
      border-radius: 0;
    }

    ::v-deep(.v-btn.v-date-picker-table__current) {
      border: 1px solid #E9CFED !important;
      color: #E9CFED !important;
      border-radius: 0 !important;
    }
    ::v-deep(.v-date-picker-table .v-btn) {
      border-radius: 0 !important; 
    }

    ::v-deep(.v-date-picker-table .v-btn:hover) {
      border-radius: 0 !important;
    }

    .c-date-picker {
      margin: 1rem 0 !important;
    }

    .description-box {
      border-radius: 30px;
      margin-top: 15px;
    }

    .name-box {
      border-radius: 30px;
    }


    .form-container{
      width: 100%;
    }

    .form-container .v-input 
    {
      margin-top: 1rem;
      margin-bottom: 2rem;
    }

    .right-image {
      width: 100%;
      height: auto;
      max-height: 100dvh;
      object-fit: cover;
    }


    .nome-h3 {
      margin-top: 40px;
    }

    .time-item {
      border-radius: 30px;
      outline: #e9cfed;
      outline-color: #e9cfed;
      font-size: 12px;
      display: flex;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      text-align: center;

      @media (min-width: 560px) {
      }
    }

    .time-item:hover {
      transform: translateY(-2px);
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
    }

    .time-dialog {
      background-color: #ffffff98;
      padding: 4px;
      margin: 4px ;
      display: flex;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }

    // .time-dialog::-webkit-scrollbar {
    //   display: none;
    // }

    .time- {
      background-color: #ffffff98;
      padding: 4px;
      margin: 4px ;
      display: flex;
    }
    

    .costumize-time-select {
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100% ;
      font-size: 12px; 
      color: #000000;

      @media (min-width: 560px)
      {
        font-size: 13px;
      }
    }

    .create-btn {
      color: white !important;
      text-transform: none !important;
    }

    .custom-date-picker {
      left: auto !important;
      right: 0 !important;
      transform: translateX(-50%) !important; /* Centraliza o date picker */
      max-width: 300px !important; /* Define um tamanho máximo para não expandir */
    }

    .back-btn {
      margin-top: 0;
      height: 40px;
      width: 40px;

      @media (min-width: 560px)
      {
        
      }
    }

    ::v-deep(.v-input__slot){
      background-color: #D9D9D957 !important;
    }
    
    @media (max-width: 768px) {
      .event-layout {
        flex-direction: column;
        height: auto;
      }

      .card-times-scroll {
        height: calc(100vh - 150px); 
        overflow-x: hidden
      }

      .form-container {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .create-button {
        margin-top: auto;
        position: relative;
        bottom: 0;
        margin-bottom: 50px;
      }

      .v-picker {
        margin-left: 0;
      }

      .v-date-picker {
        position: relative;
        overflow-y: auto;
      }

      .v-dialog {
        max-height: 80dvh !important;
        overflow-y: auto !important;
      }



    }

  /* garante layout em coluna e que o conteúdo é que rola */
.card-times-create {
  display: flex;
  flex-direction: column;
  max-height: 600px;
  /* 
    MC-330 / MC-332 6.3) - Alice Serina - 06/02/2026
    removed background transparency to avoid seeing elements behind the dialog
    and reduce visual noise.

  */
  background-color: #ffffff;
}


.card-times-create .time-row > *
{
    max-width: unset;
    flex: 1 1 40%;
    max-width: 40%;
}

/* header sempre visível */
.sticky-title {
  position: sticky;
  top: 0;
  z-index: 2;
  /* dá-lhe um fundo sólido para não “ver” o scroll por baixo */
}

/* zona scrollável */
.card-times-scroll {
  overflow: auto;
}

</style>